import React from "react";
import "./LuxurySpinner.css";

const DiamondJewelIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* 4-point faceted star / jewel */}
    <path
      d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z"
      fill="url(#jewelGoldGradient)"
    />
    <defs>
      <linearGradient id="jewelGoldGradient" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFF2D6" />
        <stop offset="0.4" stopColor="#F5B96D" />
        <stop offset="1" stopColor="#C8883B" />
      </linearGradient>
    </defs>
  </svg>
);

const LuxurySpinner = ({
  fullScreen = false,
  size = "large",
  text = null,
  subText = null,
  style = {},
  className = "",
}) => {
  const sizeClass =
    size === "small"
      ? "shz-spinner-size-small"
      : size === "medium"
      ? "shz-spinner-size-medium"
      : "shz-spinner-size-large";

  const modeClass = fullScreen ? "shz-spinner-fullscreen" : "shz-spinner-inline";

  return (
    <div
      className={`shz-spinner-container ${modeClass} ${sizeClass} ${className}`}
      style={style}
    >
      <div className="shz-spinner-graphic">
        <div className="shz-spinner-ring-outer" />
        <div className="shz-spinner-ring-inner" />
        <div className="shz-spinner-jewel">
          <DiamondJewelIcon />
        </div>
      </div>

      {text && <div className="shz-spinner-caption">{text}</div>}
      {subText && <div className="shz-spinner-subcaption">{subText}</div>}
    </div>
  );
};

export default LuxurySpinner;
